module.exports = __webpack_public_path__ + "static/media/blocker_sol_arch.06039d8e.png";